import { render } from "./EditLegalServicePayment.vue?vue&type=template&id=2b5a1800"
import script from "./EditLegalServicePayment.vue?vue&type=script&lang=js"
export * from "./EditLegalServicePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__